import { makeStyles } from "@material-ui/core";

const decompteUseStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    fontSize: "12px",
    borderRadius: "8px !important",
    marginLeft: "1%",
     maxWidth: "95vw",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
  },
  tab: {
    width: "50%",
    color: "#1976d2",
    fontSize: "24px",
    fontWeight: "bold",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  fieldset: {
     borderRadius: "10px",
    color: "#1976d2",
    fontSize: "20px",
    marginTop: "10px",
    minWidth: 0,
    overflow: "hidden",
    padding: "10px",
    maxWidth: "100%",
    width: "100%",
    boxSizing: "border-box",
     backgroundColor: "#ffffff",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
    border: "1px solid #d7e1f3",
    "& legend": {
      padding: "0 10px",
      color: "#2f5ca3",
      fontWeight: 700,
      letterSpacing: "0.2px",
    },
  },
  dialog: {
    width: "99%",
    height: "99%",
    justifyContent: "center",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "20px",
    fontSize: "12px",
  }
}));

export default decompteUseStyles;
